<template>
  <b-badge
    :variant="variant"
    :style="{ backgroundColor: color, color: textColor }"
    class="risk-level-badge"
  >
    {{ levelText }}
  </b-badge>
</template>

<script>
import { computed } from '@vue/composition-api'
import { BBadge } from "bootstrap-vue"

export default {
  name: 'RiskLevelBadge',
  components: {
      BBadge,
    },
  props: {
    level: {
      type: String,
      required: true,
      validator: value => ['Bajo', 'Medio', 'Alto', 'Muy Alto', 'Crítico', ''].includes(value),
    },
  },
  setup(props) {
    const levelText = computed(() => props.level || 'N/A')

    const color = computed(() => {
      // Colores exactos de la Plantilla Excel
      const colors = {
        Bajo: '#70AD47',
        Medio: '#FFC000',
        Alto: '#ED7D31',
        'Muy Alto': '#C00000',
        Crítico: '#823535',
      }
      return colors[props.level] || '#6c757d'
    })

    const textColor = computed(() => {
      // Texto blanco para niveles oscuros
      const darkLevels = ['Alto', 'Muy Alto', 'Crítico']
      return darkLevels.includes(props.level) ? '#ffffff' : '#000000'
    })

    const variant = computed(() => 'custom')

    return {
      levelText,
      color,
      textColor,
      variant,
    }
  },
}
</script>

<style scoped>
.risk-level-badge {
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.25rem;
}
</style>
